// extracted by mini-css-extract-plugin
export default {"root":"fsGIk2XfbF8YQd28WLKH","iconLabel":"vog0vTBQmmRWJYls0bJG","checkbox":"kvAFuqVaFzUizzMcB9os","checkboxLabel":"F5kDUjtrVneqsvpMMRJj","placeHolderShimmer":"XmNH3kQ9ZskV7dtInFX7"};